import { ActionReducerMapBuilder } from "@reduxjs/toolkit";
import {
    getBounsPointerSettingsAction,
    changeBounsPointerSettingsAction
} from "../action/bonusPointsSettingsAction";

export const bonusPointsSettingsReducer = (
    builder: ActionReducerMapBuilder<{
        getBounsPointerSettingsConfig: any;
        changeBounsPointerSettingsConfig: any;
    }>
) => {
    builder.addCase(getBounsPointerSettingsAction.fulfilled, (state, { payload }) => {
        state.getBounsPointerSettingsConfig = payload;
    });
    builder.addCase(changeBounsPointerSettingsAction.fulfilled, (state, { payload }) => {
        state.changeBounsPointerSettingsConfig = payload;
    });
};
